import useBlogPosts from "@/hooks/useBlogPosts";
import useBlogTopics from "@/hooks/useBlogTopics";
import { BlogPostCard } from "@/ui/BlogPostCard";
import { ParallaxBackground } from "@/ui/ParallaxBackground";
import cn from "classnames";
import { useMemo, useState } from "react";
import { Col, Container, Dropdown, DropdownButton, FormControl, Row, Stack } from "react-bootstrap";

import { Pagination } from "@/ui/Pagination";
import bg_1 from "./bg_1.webp";
import classes from "./styles.module.scss";

export default function ({ className = "py-5 py-md-6", theme = "light", filteredTopic }) {
  const [perPage, setPerPage] = useState(12);
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState(null);
  const [topic, setTopic] = useState(filteredTopic ?? null);
  const topics = useBlogTopics();
  const posts = useBlogPosts();

  const computedPosts = useMemo(
    () =>
      posts
        .filter((i) => (topic ? "__topics" in i && i.__topics.includes(topic.id) : true))
        .filter((i) =>
          query ? JSON.stringify(i).toLowerCase().includes(query.toLocaleLowerCase().trim()) : true,
        ),
    [query, topic, posts, page, perPage],
  );

  const pagePosts = useMemo(
    () => computedPosts.slice(perPage * (page - 1), perPage * page),
    [computedPosts, page, perPage],
  );

  const postsWithFeaturedAtFront = useMemo(
    () => pagePosts.reduce((acc, i) => (i.featured === true ? [i, ...acc] : [...acc, i]), []),
    [pagePosts],
  );

  return (
    <div className={cn(className, classes.BlogFeed)} data-bs-theme={theme}>
      <ParallaxBackground anim="y2:x1n:z0" image={bg_1} className={classes.bg_1} />
      <Container fluid="md">
        <Stack className="flex-row flex-wrap gap-2 w-100 mb-5 mw-md mx-auto">
          <div className="flex-grow-1">
            <FormControl onChange={(e) => setQuery(e.target.value)} placeholder="Search..." />
          </div>
          <div>
            <DropdownButton id="dropdown-basic-button" title={topic?.name ?? "Show All"}>
              <Dropdown.Item onClick={() => setTopic(null)}>Show All</Dropdown.Item>
              {(topics ?? []).map((t) => (
                <Dropdown.Item onClick={() => setTopic(t)}>{t?.name}</Dropdown.Item>
              ))}
            </DropdownButton>
          </div>
        </Stack>
        {/*<Stack className="flex-row flex-wrap gap-2 justify-content-center mb-5">*/}
        {/*  <Button variant={topic === null ? "cyan" : "outline-cyan"} onClick={() => setTopic(null)}>*/}
        {/*    Show All*/}
        {/*  </Button>*/}
        {/*  {(topics ?? []).map((t) => (*/}
        {/*    <Button*/}
        {/*      variant={t.id === topic ? "cyan" : "outline-cyan"}*/}
        {/*      onClick={() => setTopic(t.id)}*/}
        {/*    >*/}
        {/*      {t.name}*/}
        {/*    </Button>*/}
        {/*  ))}*/}
        {/*</Stack>*/}
        {postsWithFeaturedAtFront.length > 0 ? (
          <Row className="border-bottom">
            {postsWithFeaturedAtFront.map((post, index) => (
              <Col key={index} xs={12} md={3} className="px-0 mb-5">
                <BlogPostCard {...post} />
              </Col>
            ))}
          </Row>
        ) : (
          <Row>
            <Col xs={12} className="px-0 mb-5 text-center">
              There are no blog posts in this topic just yet.
            </Col>
          </Row>
        )}
        <Row className="py-4">
          <Pagination items={computedPosts} page={page} perPage={perPage} setPage={setPage} />
        </Row>
      </Container>
    </div>
  );
}
